
namespace RioERP.Products {
    export class ProductCategoryColumns {
        static columnsKey = 'Products.ProductCategory';
    }
}